(function (angular) {
    angular.module('bizPartEngage').config(configCoreFunction);
    configCoreFunction.$inject = ["$stateProvider", "bizUserProvider", "bizCoreProvider", "$translatePartialLoaderProvider", "bizPortalProvider"];
    function configCoreFunction($stateProvider, bizUserProvider, bizCoreProvider, $translatePartialLoaderProvider, portalProvider) {

		$stateProvider
        .state('base.modules', {
        	template: '<div ui-view></div>'
		})
		.state('base.modules.blog', {
        	url: "/modules/blogs",
        	templateUrl: bizCoreProvider.getView('base.modules.blog', 'FrontEnd/Modules/Blog/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.blogs', 'modules.blogs.list'),
        	controllerAs: "vm",
        	data: {
                rule: function () { return bizUserProvider.HasModuleAccess('BLOG', bizUserProvider.AccessTypeRight.Read); }
        	}
        })
        .state('base.modules.blogtitle', {
			url: "/blog/:title",
			params: {title: null},
            templateUrl: bizCoreProvider.getView('base.modules.blogtitle', 'FrontEnd/Modules/Blog/Views/view.html'),            
            controller: bizCoreProvider.getController('modules.blogs.show', 'modules.blogs.show'),
			controllerAs: "vm",
			data: {
                rule: function () { return bizUserProvider.HasModuleAccess('BLOG', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.blog"
			}
        }).state('base.modules.blogtag', {
        	url: "/blogtags/:tagSystemName",
            params: { id: null },
            templateUrl: bizCoreProvider.getView('base.modules.blogtag', 'FrontEnd/Modules/Blog/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.blogtag', 'modules.blogs.showbytag'),
            controllerAs: "vm",
            data: {
                rule: function () { return bizUserProvider.HasModuleAccess('BLOG', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.blog"
            }
        })
    	.state('base.modules.missions', {
    		url: "/modules/missions",
            template: '<biz-mission-list></biz-mission-list>',            
            controller: 'modules.missions',
    		controllerAs: "vm",
    		data: {
    			rule: function () { return bizUserProvider.HasModuleAccess('MISSIONS', bizUserProvider.AccessTypeRight.Read); }
    		}
    	})
    	.state('base.modules.missionsview', {
    		url: "/modules/missions/:id",
            templateUrl: bizCoreProvider.getView('base.modules.missionsview', 'FrontEnd/Modules/Missions/Views/view.html'),            
            controller: bizCoreProvider.getController('base.modules.missionsview', 'modules.missions.view'),
    		controllerAs: "vm",
    		data: {
                rule: function () { return bizUserProvider.HasModuleAccess('MISSIONS', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.missions"
    		}
    	})
        .state('base.modules.missionsusers', {
        	url: "/modules/missions/:id/users",
            templateUrl: bizCoreProvider.getView('base.modules.missionsusers', 'FrontEnd/Modules/Missions/Views/users.html'),            
            controller: bizCoreProvider.getController('base.modules.missionsusers', 'modules.missions.users'),
        	controllerAs: "vm",
        	data: {
                rule: function () { return bizUserProvider.HasModuleAccess('MISSIONS', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.missions"
        	}
        })
		.state('base.modules.educations', {
			url: "/modules/educations",
            templateUrl: bizCoreProvider.getView('base.modules.educations', 'FrontEnd/Modules/Education/Views/index.html'),
            controller: 'modules.educations',
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('EDUCATION', bizUserProvider.AccessTypeRight.Read); }
			}
        }).state('base.modules.educationtag', {
            url: "/educationtags/:tagSystemName",
            params: { id: null },
            templateUrl: bizCoreProvider.getView('base.modules.educationtag', 'FrontEnd/Modules/Education/Views/Index.html'),
            controller: bizCoreProvider.getController('base.modules.educationtag', 'modules.educations'),
            controllerAs: "vm",
            data: {
                rule: function () { return bizUserProvider.HasModuleAccess('EDUCATION', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.educations"
            }
        })
		.state('base.modules.html5education', {
			url: "/modules/education/html5/:id",
			templateUrl: bizCoreProvider.getView('base.modules.html5education', 'FrontEnd/Modules/Education/Views/html5education.html'),            
            controller: bizCoreProvider.getController('base.modules.html5education', 'modules.educations.html5'),
			controllerAs: "vm",
			data: {
                rule: function () { return bizUserProvider.HasModuleAccess('EDUCATION', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.educations"
			}
		})
		.state('base.modules.cms', {
			url: "/page/:id",
			templateUrl: bizCoreProvider.getView('base.modules.cms', 'FrontEnd/Modules/CMS/Views/page.html'),            
            controller: bizCoreProvider.getController('base.modules.cms', 'modules.cms.page'),
            controllerAs: "vm",
            params: {
                params: null //optional params that can be used in modules that might be on the page
            },
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('CMS', bizUserProvider.AccessTypeRight.Read); }
			}
		})
		.state('base.modules.forums', {
			url: "/modules/forums",
			templateUrl: bizCoreProvider.getView('base.modules.forums', 'FrontEnd/Modules/Forum/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.forums', 'modules.forums'),
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('FORUM', bizUserProvider.AccessTypeRight.Read); }
			}
		})
		.state('base.modules.forum', {
			url: "/modules/forum/:id",
			templateUrl: bizCoreProvider.getView('base.modules.forum', 'FrontEnd/Modules/Forum/Views/viewforum.html'),            
            controller: bizCoreProvider.getController('base.modules.forum', 'modules.forum'),
			controllerAs: "vm",
			data: {
                rule: function () { return bizUserProvider.HasModuleAccess('FORUM', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.forums"
			}
		})
		.state('base.modules.forumthread', {
			url: "/modules/forum-thread/:id",
			templateUrl: bizCoreProvider.getView('base.modules.forumthread', 'FrontEnd/Modules/Forum/Views/viewforumthread.html'),            
            controller: bizCoreProvider.getController('base.modules.forumthread', 'modules.forum.thread'),
			controllerAs: "vm",
			data: {
                rule: function () { return bizUserProvider.HasModuleAccess('FORUM', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.forums"
			}
		}).state('base.modules.dictionary', {
			url: "/modules/dictionary",
			templateUrl: bizCoreProvider.getView('base.modules.dictionary', 'FrontEnd/Modules/Dictionary/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.dictionary', 'modules.dictionary'),
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('DICTIONARY', bizUserProvider.AccessTypeRight.Read); }
			}
		}).state('base.modules.dictionaryitem', {
			url: "/modules/dictionary/:id",
			templateUrl: bizCoreProvider.getView('base.modules.dictionary', 'FrontEnd/Modules/Dictionary/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.dictionary', 'modules.dictionary'),
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('DICTIONARY', bizUserProvider.AccessTypeRight.Read); }
			}
		}).state('base.modules.events', {
			url: "/modules/events",
			templateUrl: bizCoreProvider.getView('base.modules.events', 'FrontEnd/Modules/Event/Views/list-react.html'),
			controller: bizCoreProvider.getController('base.modules.events', 'modules.events'),
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('EVENT', bizUserProvider.AccessTypeRight.Read); }
			}
		}).state('base.modules.eventsfilter', {
			url: "/modules/events/:filter",
			templateUrl: bizCoreProvider.getView('base.modules.events', 'FrontEnd/Modules/Event/Views/list-react.html'),
			controller: bizCoreProvider.getController('base.modules.events', 'modules.events'),
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('EVENT', bizUserProvider.AccessTypeRight.Read); }
			}
		}).state('base.modules.event', {
			url: "/modules/event/:id",
			templateProvider: ['$stateParams', function ($stateParams) {
				return `<div id="bizoneevent" biz-react-wrapper params="{eventId: ${$stateParams.id}}"></div>`;
			}],			
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('EVENT', bizUserProvider.AccessTypeRight.Read); }
			}
		}).state('base.modules.media', {
		    url: "/modules/media/",
		    templateUrl: bizCoreProvider.getView('base.modules.media', 'FrontEnd/Modules/Media/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.media', 'modules.media'),
		    controllerAs: "vm",
		    data: {
		        rule: function () { return bizUserProvider.HasModuleAccess('MEDIABANK', bizUserProvider.AccessTypeRight.Read); }
		    }
		}).state('base.modules.mediafile', {
		    url: "/modules/media/:id",
		    templateUrl: bizCoreProvider.getView('base.modules.mediafile', 'FrontEnd/Modules/Media/Views/viewfile.html'),            
            controller: bizCoreProvider.getController('base.modules.mediafile', 'modules.media'),
		    controllerAs: "vm",
		    data: {
                rule: function () { return bizUserProvider.HasModuleAccess('MEDIABANK', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.media"
		    }
		}).state('base.modules.mediatagsfileid', {
			url: "/mediatags/:tagSystemName/:fileId",
            templateUrl: bizCoreProvider.getView('base.modules.mediatags', 'FrontEnd/Modules/Media/Views/viewtags.html'),            
            controller: bizCoreProvider.getController('base.modules.mediatags', 'modules.mediatags'),
			controllerAs: "vm",
			data: {
                rule: function () { return bizUserProvider.HasModuleAccess('MEDIABANK', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.media"
			}
		}).state('base.modules.mediatags', {
			url: "/mediatags/:tagSystemName",
            templateUrl: bizCoreProvider.getView('base.modules.mediatags', 'FrontEnd/Modules/Media/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.mediatags', 'modules.mediatags'),
			controllerAs: "vm",
			data: {
                rule: function () { return bizUserProvider.HasModuleAccess('MEDIABANK', bizUserProvider.AccessTypeRight.Read); },
                parentState: "base.modules.media"
			}		
		}).state('base.modules.search', {
		    url: "/modules/search/?:query",
		    templateUrl: bizCoreProvider.getView('base.modules.search', 'FrontEnd/Modules/Search/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.search', 'modules.search'),
		    controllerAs: "vm",
            data: {
                rule: function () { return bizUserProvider.IsLoggedIn() || portalProvider.IsPortalPublic(); }
		    }
		}).state('base.modules.masterrun', {
			url: "/modules/masterrun",
			templateUrl: bizCoreProvider.getView('base.modules.masterrun', 'FrontEnd/Modules/MasterRun/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.masterrun', 'modules.masterrun'),
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('MASTER_RUN', bizUserProvider.AccessTypeRight.Read); }
            }        
        }).state('base.modules.journey', {
			url: "/modules/journey",
			templateUrl: bizCoreProvider.getView('base.modules.journey', 'FrontEnd/Modules/Journey/Views/index.html'),            
            controller: bizCoreProvider.getController('base.modules.journey', 'modules.journey'),
			controllerAs: "vm",
			data: {
				rule: function () { return true; return bizUserProvider.HasModuleAccess('ENGAGEMENT_GOAL', bizUserProvider.AccessTypeRight.Read); } // todo
			}
        })        
		.state('base.modules.speedquiz', {
            url: "/modules/speedquiz",
            params: { urlRewrite: null, pluginInstanceId: null },
			templateUrl: bizCoreProvider.getView('base.modules.speedquiz', 'FrontEnd/Modules/SpeedQuiz/Views/list.html'),
			controller: "modules.speedquiz.list",
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('SPEEDQUIZ', bizUserProvider.AccessTypeRight.Read); }
			}	
        })
        .state('base.modules.speedquizone', {
            url: "/modules/speedquiz/:urlRewrite/:pluginInstanceId",
            params: { urlRewrite: null, pluginInstanceId: null },
            templateUrl: bizCoreProvider.getView('base.modules.speedquiz', 'FrontEnd/Modules/SpeedQuiz/Views/list.html'),
            controller: "modules.speedquiz.list",
            controllerAs: "vm",
            data: {
                rule: function () { return bizUserProvider.HasModuleAccess('SPEEDQUIZ', bizUserProvider.AccessTypeRight.Read); }
            }
        })
		.state('base.modules.speedquizplay', {
			url: "/modules/speedquiz/play/:id/:pluginInstanceId",
			templateUrl: bizCoreProvider.getView('base.modules.speedquiz.play', 'FrontEnd/Modules/SpeedQuiz/Views/play-react.html'),
			controller: "modules.speedquiz.play",
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('SPEEDQUIZ', bizUserProvider.AccessTypeRight.Read); }
			}	
        })
		.state('base.modules.speedquizplayfromone', {
			url: "/modules/speedquiz/play-one/:id/:pluginInstanceId",
			params: {
				fromOneQuiz: true
			},
			templateUrl: bizCoreProvider.getView('base.modules.speedquiz.play', 'FrontEnd/Modules/SpeedQuiz/Views/play-react.html'),
			controller: "modules.speedquiz.play",
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('SPEEDQUIZ', bizUserProvider.AccessTypeRight.Read); }
			}
		})
		.state('base.modules.speedquizhighscore', {
			url: "/modules/speedquiz/highscore/:pluginInstanceId/:name",
			templateUrl: bizCoreProvider.getView('base.modules.speedquiz.highscore', 'FrontEnd/Modules/SpeedQuiz/Views/highscore.html'),
			controller: "modules.speedquiz.highscore",
			controllerAs: "vm",
			data: {
				rule: function () { return bizUserProvider.HasModuleAccess('SPEEDQUIZ', bizUserProvider.AccessTypeRight.Read); }
			}	
        }).state('base.modules.campaign', {
			url: "modules/campaign/:urlRewrite?referer",
			controller: "modules.campaign",
			controllerAs: "vm"
		})
		.state('base.modules.campaign.page', {
			url: "/:pageUrlRewrite",
			templateUrl: bizCoreProvider.getView('base.modules.campaign', 'FrontEnd/Modules/Campaign/Views/default.html'),
			controller: "modules.campaign.page",
			controllerAs: "vm"		
        })
        .state('base.modules.certifications', {
            url: "/modules/certifications",
            templateUrl: bizCoreProvider.getView('base.modules.certifications', 'FrontEnd/Modules/Certifications/Views/default.html'),
            controller: 'modules.certifications',
            controllerAs: "vm",
            data: {
                rule: function () { return bizUserProvider.HasModuleAccess('CERTIFICATIONS', bizUserProvider.AccessTypeRight.Read); }
            }
        })
        .state('base.modules.engageobjectredirect', {
            url: "/modules/eor/:type/:id",
            controller: EngageObjectRedirectController,
            controllerAs: "vm"            
        });

        EngageObjectRedirectController.$inject = ["$stateParams", "core.engage.service"];
        function EngageObjectRedirectController($stateParams, coreEngageService) {            
            vm = this;
            vm.EngageObjectType = $stateParams.type;
            vm.EngageObjectId = $stateParams.id;
            coreEngageService.RedirectToEngageObject(vm.EngageObjectType, vm.EngageObjectId);
        }		
    }

})(window.angular);
